<template>
  <div>
    <label
      v-if="label"
      :for="name"
      class="text-background-fg/70 mb-1 block text-xs font-medium"
    >
      {{ label }}
    </label>
    <BasePercentageInput
      :model-value="inputValue"
      :has-error="hasError"
      class="mb-1"
      :highlight="highlight"
      :disabled="disabled"
      @update:model-value="handleChange"
    />
    <template v-if="hasError">
      <p class="text-error mt-1 text-xs font-medium">
        {{ errorMessage }}
      </p>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate"
const props = withDefaults(
  defineProps<{
    name: string
    label: string
    placeholder?: string
    highlight?: boolean
    disabled?: boolean
  }>(),
  {
    type: "text",
    placeholder: "",
  }
)

const {
  value: inputValue,
  errorMessage,
  handleChange,
} = useField(toRef(props, "name"), undefined, {
  initialValue: 0,
})

const hasError = computed(() => !!errorMessage.value)
</script>
